module.exports = __webpack_public_path__ + "img/62.57846a80.jpg";